import { Component, ViewChild, AfterViewInit, ChangeDetectorRef, inject } from '@angular/core';
import { tableModel } from '../../../components/table/model/tableModel';
import { TableComponent } from '../../../components/table/table.component';
import { Division } from '../../../models/division';
import { Router } from '@angular/router';
import { FilterDivisions } from '../../../models/filters/filter-division';
import { DivisionService } from '../../../services/division.service';
import { MatExpansionPanel } from '@angular/material/expansion';
import { AlertaService } from '../../../services/alerta.service';

@Component({
  selector: 'app-divisions',
  standalone: false,
  templateUrl: './divisions.component.html',
  styleUrl: './divisions.component.css'
})
export class DivisionsComponent implements AfterViewInit {

  @ViewChild(TableComponent) divisionsTable:TableComponent | undefined;
  @ViewChild('advancedPanel') advancedPanel!: MatExpansionPanel;

  tableModel: tableModel= {
    columnModel:[{columnName:'C\u00F3digo',columnValue:'code'},
      {columnName:'Descripci\u00F3n',columnValue:'description'},
      {columnName:'Activo',columnValue:'active'}],
    dataSource:[],
    editButton:true
  };
  division: Division = new Division();

  pageIndex: number = 1;
  pageSize: number = 5;
  loading: boolean = false;
  filterDivisions: FilterDivisions = new FilterDivisions;
  advancedSearch: boolean = false;

  private divisionService = inject(DivisionService);
  router = inject(Router);
  private cdr = inject(ChangeDetectorRef);
  private alerta = inject(AlertaService);
  
  constructor(
    //private dialog: MatDialog
  ) {

  }

  ngAfterViewInit() {
    //Promise.resolve().then(() =>  this.divisionsTable.initTable());
  }

  ngOnInit(): void {
    this.searchDivisionsPaginator();
  }
  editEvent(event: any){
    this.router.navigate(['/divisions/edit', event.id]);
    /*const dialogRef = this.dialog.open(DivisionsDetailComponent, {
      data: {
        division: event,
        readOnly: false
      }
    });*/
  }
  paginatorEvent(event: any){
    this.pageIndex = (event.pageIndex+1);
    this.pageSize = event.pageSize;
    this.searchDivisionsPaginator();
  }

  /*onShowAgregar(): void {
    const dialogRef = this.dialog.open(DivisionsDetailComponent, {
      data: {
        division: undefined,
        readOnly: false
      }
    });
  }*/
  
  searchDivisionsPaginatorAS(){
    this.pageIndex = 1;
    this.advancedSearch = true;
    this.searchDivisionsPaginator();
  }
  searchDivisionsPaginator(){
    this.loading = true;

    this.divisionService.findAllPageableDivisions(this.filterDivisions, this.pageIndex, this.pageSize).subscribe({
      next: (pageable) => {
        this.tableModel.pageSize = pageable.pageSize;
        this.tableModel.totalRecords = pageable.itemsCount;
        this.tableModel.dataSource = pageable.list;
        this.tableModel.pageNumber = pageable.pageNum;
        
        setTimeout(() => {
          this.divisionsTable?.refresh(pageable.list, pageable.itemsCount);
        });
        this.loading = false;
        this.cdr.detectChanges();
      },
      error: (err) => {
        this.loading = false;
        if(err.status == 400){
          this.alerta.error("Se ha terminado el tiempo de session: ", {detail: err.message});
          this.router.navigate(['/login']);
        }else{
          this.alerta.error("Se ha precentado un error interno: ", {detail: err.message});
        }
      }
    });

    if(this.advancedPanel != null){
      if (this.advancedSearch) {
        this.advancedPanel.open();
      } else {
        this.advancedPanel.close();
      }
    }
  }

}
